import * as React from 'react';
import { isMobile } from 'react-device-detect';
import { Block, Heading, Text } from '@/presentation/components';
import { InteractiveButton } from '@/presentation/modules/procedures/components';
import iconExists from '../../../../../assets/illustrations/exists-procedure.svg';

interface RequestExistProps {
  handleClick: () => void;
  rectificationNotes?: boolean;
  textInformation?: string;
  styled?: React.CSSProperties | any;
}
const RequestExist: React.FC<RequestExistProps> = (props) => {
  const { handleClick, rectificationNotes, textInformation, styled } = props;
  return (
    <>
      <Block
        customized
        maxWidth={isMobile ? '100%' : '496px'}
        backgroundColor="#fff"
        padding="0px 32px 32px 32px"
        margin="8px 0px 0px 0px"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Block
          customized
          display="flex"
          justifyContent="center"
          alignItems="center"
          margin="0px 0px 16px"
        >
          <img src={iconExists} alt="error" />
        </Block>
        <Heading
          text={
            rectificationNotes
              ? 'Estamos registrando tu solicitud'
              : textInformation ??
                'Actualmente este trámite ya se encuentra en proceso.'
          }
          level={2}
          color="#161D1F"
          size={styled?.fontSize ?? 20}
          lineHeight={styled?.lineHeight ?? 32}
          fontWeight={styled?.fontWeight ?? 900}
          className=""
          align="center"
          width="100%"
        />
        {rectificationNotes ? (
          <span
            style={{
              fontSize: '14px',
              fontWeight: '400',
              marginTop: 12,
              marginBottom: 12,
              textAlign: 'center'
            }}
          >
            {'En breve te informaremos sobre el estado.'}
          </span>
        ) : null}
        <InteractiveButton
          data-testid="pse-go-progress"
          bkgColorEnabled="#5B36F2"
          bkgColorHover="#745EF6"
          bkgColorFocus="#4318CD"
          bkgColorPressed="#4318CD"
          customized
          as="button"
          alignItems="center"
          backgroundColor="#5B36F2"
          padding="10px 16px"
          borderRadius="4px"
          margin="40px 0px 0px 0px"
          width={isMobile ? '100%' : '97px'}
          onClick={() => handleClick()}
        >
          <Text
            color="#FFFFFF"
            fontSize="14px"
            lineHeight="20px"
            fontWeight="700"
            textAlign="center"
          >
            Entendido
          </Text>
        </InteractiveButton>
      </Block>
    </>
  );
};

export default RequestExist;
